import { Fragment, type ReactNode } from "react";

/**
 * Renders a translated sentence with one interpolated value in bold, keeping the translator's
 * word order: call `t(key, { name: EMPHASIS_TOKEN })`, then pass the result and the real value.
 */
export const EMPHASIS_TOKEN = "⁣EM⁣";

export function Emphasize({ text, value }: { text: string; value: string }): ReactNode {
  const parts = text.split(EMPHASIS_TOKEN);
  return parts.map((part, index) => (
    <Fragment key={index}>
      {part}
      {index < parts.length - 1 ? <strong className="text-fg">{value}</strong> : null}
    </Fragment>
  ));
}
